import { MaRound } from 'src/app/domain/recovery/component/recovery-market-analysis/pojo/ma-classes';
import { Rows } from '../../../interfaces';
import { MA_ALL_ROUNDS_HEADERS } from 'src/app/domain/recovery/component/recovery-market-analysis/ma-all-rounds/ma-all-rounds.component';
import { DataType, formats, getCell, spaceInsteadOfNull, withCellStyles } from '../../../utils';
import { left } from 'src/app/util/excelStyles';

export const getPreparedData = (data: MaRound[]): Rows => {
  const newData: Rows = [];
  const headers = [...MA_ALL_ROUNDS_HEADERS];
  newData.push(headers);
  const mainRows = getManyRows(data, headers);
  newData.push(...mainRows);
  return newData;
};

const getManyRows = (rounds: MaRound[], headers: string[]): Rows => {
  const rows: Rows = [];
  const mappedToHeaders = rounds.map((r: MaRound) => getNewMapping(r));
  for (const mapped of mappedToHeaders) {
    const row = [];
    for (const header of headers) {
      row.push(withCellStyles(mapped[header] as DataType, left));
    }
    rows.push(row);
  }
  return rows;
};

const getNewMapping = (round: MaRound): object => {
  const body = {
    'Company name': round.companyName,
    Industry: round.sector ?? '',
    'Round name': round.roundName ?? '',
    'Round date': round.roundDate ?? '',
    Investment: getCell({
      v: spaceInsteadOfNull(round.cost),
      z: formats.thousandsSeparator,
      t: 'n',
    }),
    FMV: getCell({
      v: spaceInsteadOfNull(round.fmv),
      z: formats.thousandsSeparator,
      t: 'n',
    }),
    Raised: getCell({
      v: spaceInsteadOfNull(round.totalRound),
      z: formats.thousandsSeparator,
      t: 'n',
    }),
    'Post money': getCell({
      v: spaceInsteadOfNull(round.postMoney),
      z: formats.thousandsSeparator,
      t: 'n',
    }),
  };
  return body;
};
